import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { PrevRouteService } from '../../../../routing/services/prev-route.service';
import { Router, NavigationEnd } from '@angular/router';
import { Storage } from '@ionic/storage';

const FIVE_MIN_IN_MILLISECONDS = 300000;

@Component({
  selector: 'inc-ch-base',
  template: ''
})
export class ChBaseComponent {
  mustLoginAgain = false;
  form: FormGroup;
  lastPageName: string;
  currentRoute: string;

  constructor(private prevRouteService: PrevRouteService, protected router: Router, protected storage: Storage) {
    this.lastPageName = this.prevRouteService.getPreviousUrl();
    this.setMustRelogin();
    this.currentRoute = this.router.url;
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) { this.setMustRelogin(); }
    });
  }

  setMustRelogin() {
    this.storage.get('user').then((user) => {
      if (user) {
        const dateString = user.lastSignInTime;
        if (dateString) {
          const date = new Date(dateString);
          const currentDate: Date = new Date();
          this.mustLoginAgain = currentDate.getTime() - date.getTime() > FIVE_MIN_IN_MILLISECONDS;
        } else {
          this.mustLoginAgain = true;
        }
      }
    });
  }

}
